import React from 'react';
import Avatar from '@atlaskit/avatar';
import Lozenge from '@atlaskit/lozenge';
import { useIntl } from '@atlassian/jira-intl';
import { CellItem } from '../../../common/ui/styled';
import type { Priority } from '../../../common/ui/types';
import messages from './messages';

type PriorityCellProps = {
	priorities: Priority[];
};

export const PriorityCell = ({ priorities }: PriorityCellProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			{priorities.map(({ id, name, isDefault, iconUrl }) => (
				<CellItem key={id}>
					<Avatar appearance="circle" label={name} size="xsmall" src={iconUrl} />
					<span>{name}</span>
					{isDefault && <Lozenge>{formatMessage(messages.defaultPriority)}</Lozenge>}
				</CellItem>
			))}
		</>
	);
};
